import { MediaSet } from './media-set';
import { Provider } from './provider';

export class MediaSetSelectDialog {
  provider: Provider;
  excludeMediaSetIds: Array<string>;
}
